__turbopack_context__.v({
  "field": "NumberField-module__M4YW7q__field",
  "prefix": "NumberField-module__M4YW7q__prefix",
  "suffix": "NumberField-module__M4YW7q__suffix",
});
